const handlePopin = () => {

	const popup = document.querySelector('.announcement-bar');
	const button = document.querySelector('.announcement-bar__button')
	const wrapper = document.getElementById('shopify-section-announcement-bar')
	const popin = getCookie('popin');

	if(!popup || !button || !wrapper) return
	if (wrapper) document.body.style.overflow = 'hidden'


	if(popin === 'closed') {
		wrapper.classList.add('popout');
		document.body.style.overflow = 'auto'
	}

	if (button) {
		const handleClick = () => {
			if (wrapper && popup) {
				popup.classList.add('popout')
				setTimeout( () => wrapper.classList.add('popout'), 316)
				document.body.style.overflow = 'auto';
				button.removeEventListener('click', handleClick)

				let date = new Date(Date.now() + 604800000); //604800000 = 1 week
				date = date.toUTCString();
				document.cookie = 'popin=closed; path=/; expires=' + date;
			}
		}

		button.addEventListener('click', handleClick)
	}
}

handlePopin()


function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}